import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import applyFormTheme from './applyFormTheme';
import { formThemeShape } from './PropTypes';
import style from './Fieldset.scss';

const Fieldset = ({ children, className, legend, horizontal, ...props }, { formTheme }) => {
  const theme = applyFormTheme(formTheme, { horizontal });
  if (legend) {
    legend = <legend className={classNames(style.fieldset__legend)}>{legend}</legend>;
  }
  return (
    <fieldset
      className={classNames(
        style.fieldset,
        theme.horizontal && style['fieldset--horizontal'],
        className
      )}
      {...props}
    >
      {legend}
      {children}
    </fieldset>
  );
};

Fieldset.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  legend: PropTypes.node,
  horizontal: PropTypes.bool,
};

Fieldset.contextTypes = {
  formTheme: formThemeShape,
};

export default Fieldset;
